module.exports = __webpack_public_path__ + "img/3SacredTreasures_DG.7a5de3ad.jpg";